import { useState, useEffect } from "react";

export default function LoyaltyPage() {
  const [customers, setCustomers] = useState([]);
  const [form, setForm] = useState({ id: null, name: "", phone: "", email: "" });
  const [selectedLog, setSelectedLog] = useState(null); // { customer, log[] }
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => { loadCustomers(); }, []);

 const loadCustomers = async () => {
    try {
      const res  = await fetch("/api/loyalty/list.php");
      const data = await res.json();
      setCustomers(data.success ? (data.data || []) : []);
    } catch (e) {
      console.error("Error cargando clientes:", e);
      setCustomers([]);
    }
  };

  const handleSave = async () => {
    if (!form.name.trim()) { setMsg("El nombre es requerido"); return; }
    setLoading(true);
    const res = await fetch("/api/loyalty/save_customer.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form)
    });
    const data = await res.json();
    if (data.success) {
      setMsg(form.id ? "Cliente actualizado" : "Cliente registrado ✓");
      setForm({ id: null, name: "", phone: "", email: "" });
      loadCustomers();
    } else {
      setMsg(data.error || "Error al guardar");
    }
    setLoading(false);
    setTimeout(() => setMsg(""), 3000);
  };

  const handleEdit = (c) => {
    setForm({ id: c.id, name: c.name, phone: c.phone || "", email: c.email || "" });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleViewLog = async (c) => {
    const res = await fetch(`/api/loyalty/get_log.php?customer_id=${c.id}`);
    const log = await res.json();
    setSelectedLog({ customer: c, log });
  };

  return (
    <div style={{ padding: 16, maxWidth: 700, margin: "0 auto" }}>
      <h2 style={{ color: "#3F1907", marginBottom: 16 }}>⭐ Clientes Frecuentes</h2>

      {/* Formulario */}
      <div style={{
        background: "#fdf8f5", border: "1px solid #e8d5c4",
        borderRadius: 12, padding: 16, marginBottom: 20
      }}>
        <h3 style={{ margin: "0 0 12px", fontSize: 15, color: "#3F1907" }}>
          {form.id ? "Editar cliente" : "Registrar cliente"}
        </h3>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <input
            placeholder="Nombre *"
            value={form.name}
            onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
            style={{ padding: "9px 12px", borderRadius: 8, border: "1px solid #ccc", fontSize: 14 }}
          />
          <input
            placeholder="Teléfono"
            value={form.phone}
            onChange={e => setForm(f => ({ ...f, phone: e.target.value }))}
            style={{ padding: "9px 12px", borderRadius: 8, border: "1px solid #ccc", fontSize: 14 }}
          />
          <input
            placeholder="Email"
            value={form.email}
            onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
            style={{ padding: "9px 12px", borderRadius: 8, border: "1px solid #ccc", fontSize: 14 }}
          />
          <div style={{ display: "flex", gap: 8 }}>
            {form.id && (
              <button
                onClick={() => setForm({ id: null, name: "", phone: "", email: "" })}
                style={{
                  flex: 1, padding: 10, borderRadius: 8,
                  border: "1px solid #ccc", background: "#fff", cursor: "pointer"
                }}
              >Cancelar</button>
            )}
            <button
              onClick={handleSave}
              disabled={loading}
              style={{
                flex: 2, padding: 10, borderRadius: 8,
                border: "none", background: "#3F1907",
                color: "#fff", fontWeight: 600, cursor: "pointer", fontSize: 14
              }}
            >{loading ? "Guardando..." : form.id ? "Actualizar" : "Registrar"}</button>
          </div>
          {msg && <div style={{ fontSize: 13, color: "#3F1907" }}>{msg}</div>}
        </div>
      </div>

      {/* Tabla de clientes */}
      {customers.length === 0 ? (
        <p style={{ color: "#888", textAlign: "center" }}>Sin clientes registrados aún</p>
      ) : (
        customers.map(c => (
          <div key={c.id} style={{
            background: "#fff", border: "1px solid #e8d5c4",
            borderRadius: 10, padding: "12px 14px", marginBottom: 10,
            display: "flex", justifyContent: "space-between", alignItems: "center"
          }}>
            <div>
              <div style={{ fontWeight: 700, color: "#3F1907" }}>{c.name}</div>
              <div style={{ fontSize: 12, color: "#888" }}>
                {c.phone || "—"} · ⭐ {c.points} pts · 🏆 {c.visits} visitas
              </div>
              <div style={{ fontSize: 11, color: "#aaa", marginTop: 2 }}>
                QR: {c.qr_code}
              </div>
            </div>
            <div style={{ display: "flex", gap: 6 }}>
              <button onClick={() => handleViewLog(c)} style={{
                padding: "6px 10px", borderRadius: 6,
                border: "1px solid #ccc", background: "#fff",
                cursor: "pointer", fontSize: 12
              }}>📋 Log</button>
              <button onClick={() => handleEdit(c)} style={{
                padding: "6px 10px", borderRadius: 6,
                border: "none", background: "#3F1907",
                color: "#fff", cursor: "pointer", fontSize: 12
              }}>Editar</button>
            </div>
          </div>
        ))
      )}

      {/* Modal de historial */}
      {selectedLog && (
        <div style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
          display: "flex", alignItems: "center", justifyContent: "center", zIndex: 200
        }}>
          <div style={{
            background: "#fff", borderRadius: 14, padding: 20,
            width: 340, maxHeight: "80vh", overflowY: "auto",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
              <h3 style={{ margin: 0, color: "#3F1907" }}>
                {selectedLog.customer.name}
              </h3>
              <button onClick={() => setSelectedLog(null)} style={{
                border: "none", background: "none", fontSize: 18, cursor: "pointer"
              }}>✕</button>
            </div>
            <div style={{ marginBottom: 12, fontSize: 14, color: "#555" }}>
              Saldo actual: <strong>{selectedLog.customer.points} pts</strong>
            </div>
            {selectedLog.log.length === 0 ? (
              <p style={{ color: "#aaa", textAlign: "center" }}>Sin movimientos</p>
            ) : (
              selectedLog.log.map((entry, i) => (
                <div key={i} style={{
                  display: "flex", justifyContent: "space-between",
                  padding: "8px 0", borderBottom: "1px solid #f0f0f0", fontSize: 13
                }}>
                  <div>
                    <div>{entry.concept}</div>
                    <div style={{ fontSize: 11, color: "#aaa" }}>
                      {new Date(entry.created_at).toLocaleDateString("es-MX")}
                    </div>
                  </div>
                  <div style={{
                    fontWeight: 700,
                    color: entry.points_change > 0 ? "#58735A" : "#c0392b"
                  }}>
                    {entry.points_change > 0 ? "+" : ""}{entry.points_change}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}